<script setup>

const props = defineProps({
    content: {
        type: Object,
        required: true
    },
})

</script>

<template>
    <div
        :style="{height: content?.height ?? '0px'}"
    ></div>
</template>
